// https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3751215124/BSB+Enums
export enum ToastTypeEnum {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    INFO = 'INFO'
}
